import { useSelectedSections } from './components/selected_sections'

export const useGoBack = () => {
  const { selectedSections, closeCurrentSection } = useSelectedSections()

  return () => {
    if (selectedSections.length) {
      closeCurrentSection()
    }
  }
}
